<!-- Bubble Chart Section -->
<div class="bubble-chart-container" *ngIf="!isLoading; else loadingTemplate">
  <ng-container *ngIf="byIssuesData.length; else noDataTemplate">
    <service-details-bubble-chart (bubbleClick)="handleTooltipClick($event)"
      [title]="pageTitle"
      [data]="byIssuesData"
      [showTooltip]="false">
    </service-details-bubble-chart>
  </ng-container>
</div>

<!-- Location Details Table Section -->
<div class="location-details-table-container" style="width:100%">
  <div class="paginator-header">
      <div class="paginator-container">
        <mat-paginator #paginator
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [length]="totalRows"
        (page)="onPageChange($event)" aria-label="Select page"></mat-paginator>
      </div>
  </div>

  <div class="loaderPlaceholder" *ngIf="showTableLoader">
      <loader class="ml-10 mt-6" [size]="'medium'">
      </loader>
  </div>
  <div *ngIf="isExportPhotoView">
    <service-insights-photo-gallery
    ></service-insights-photo-gallery>
</div>

  <div *ngIf="!showTableLoader">
      <ng-container *ngIf="!noLocationsData; else noDataTemplate">
        <div *ngFor="let item of filteredLocationData; let i = index" [id]="'ph-location-details-table-' + i">
          <div class="obsData">
              <div class="obsStatus">
                  <div class="call-status">
                      {{item.status}}
                  </div>
                  <div class="call-date sub-text">
                      {{item.endDate | date:'longDate'}}
                  </div>
              </div>
              <div class="obsCustomer">
                  <div class="cust-name">{{item.accountName}}</div>
                  <div class="address sub-text">
                    {{item.shippingCity}}, {{item.shippingState}}
                  </div>
              </div>
              <div class="obsService">
                  <div class="call-label">
                      {{item.callReason}}
                      <!-- Show Virtual Visit Icon if set to true -->
                       <span class="virtual-visit-icon" *ngIf="item.virtualVisit" >
                        <img src="assets/virtual-visit-icon.svg" alt="Virtual Visit Icon">
                       </span>
                  </div>

                  <!-- View Report Link -->
                  <div *ngIf="item.pdfBaseUrl!=undefined" class="view-report sub-text">
                      <a target="_blank"
                      (click)="downloadWorkOrder(item.pdfBaseUrl, item)">
                      View Report
                      </a>
                  </div>
              </div>
              <div class="observations-number">
                  <div class="td-cell-gray-backdrop">
                      <div class="obs-count">{{item.obsCount}}</div>
                      <div class="obs-text sub-text">observations</div>
                  </div>

                  <div class="td-cell-gray-backdrop">
                      <div class="part-count">{{item.issuesCount}}</div>
                      <div class="part-text sub-text">issues</div>
                  </div>
              </div>
              <div class="thumbnail-section">
                <div class="thumbnail-grid" *ngIf="item.photoInfo.length > 0">
                    <div *ngFor="let photo of item.photoInfo.slice(0, 4)" class="thumbnail location-details-photo-urls" id="{{item.workOrderId}}" (click)="openPhotoInNewTab(item)">
                    <img [src]="photo.photoBaseUrl" alt="photo.photoDescription">
                    </div>
                    <span *ngIf="item.photoInfo.length > 4" class="remaining-photos" (click)="openPhotoInNewTab(item)">
                      +{{item.photoInfo.length - 4}}
                    </span>
                </div>
            </div>

          </div>
        </div>
      </ng-container>

      <!-- <ng-template #noData>
          <div class="no-data" >No Data Available</div>
      </ng-template> -->
  </div>
</div>

<!-- Loading Template -->
<ng-template #loadingTemplate>
  <div class="loading-container">
    <loader size="medium"></loader>
    <p>Loading...</p>
  </div>
</ng-template>

<ng-template #noDataTemplate>
  <div class="no-data-container">
    <p>No data available</p>
  </div>
</ng-template>

